

















import { Component } from 'vue-property-decorator';
import TemplateMixin from '../TemplateMixin.vue';
import QuillEditor from '@/views/components/quill-editor.vue';

/**
 * 自定义字段展示列表
 *
 * @author liyuyao
 * @date 03/12/2020
 */
@Component({
    components: {
        QuillEditor
    }
})
export default class ComponentDesc extends TemplateMixin {
    $refs: { editor: QuillEditor };

    handleDescChange(val: string) {
        this.value = val;
    }

    mounted() {
        const editor = this.$refs.editor;
        if (this.readonly) {
            editor && editor.enable(false);
        }
    }
}
